import { render, staticRenderFns } from "./options-tour-manual.vue?vue&type=template&id=62032f2a&scoped=true&"
import script from "./options-tour-manual.vue?vue&type=script&lang=js&"
export * from "./options-tour-manual.vue?vue&type=script&lang=js&"
import style0 from "./options-tour-manual.vue?vue&type=style&index=0&id=62032f2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62032f2a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62032f2a')) {
      api.createRecord('62032f2a', component.options)
    } else {
      api.reload('62032f2a', component.options)
    }
    module.hot.accept("./options-tour-manual.vue?vue&type=template&id=62032f2a&scoped=true&", function () {
      api.rerender('62032f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/components/options-tour-manual/options-tour-manual.vue"
export default component.exports